import { ERROR_MESSAGES } from 'constants/validation-error-messages';
import * as yup from 'yup';

export const schema = yup.object({
    login: yup.string().required(ERROR_MESSAGES.REQUIRED),
    password: yup.string().required(ERROR_MESSAGES.REQUIRED),
});
